import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { ReactNode } from "react";
import Link from "src/components/buttons/LinkButton";
import { useStore } from "src/stores/Store";
import { cf } from "src/styles/utility";
import colors from "src/utils/colors";

interface Props {
  type?: string;
  className?: string;
  to?: any;
  href?: string;
  onClick?: React.MouseEventHandler<any>;
  onClickMove?: React.MouseEventHandler<any>;
  isDetail?: boolean;
  isActive?: boolean;
  approved?: boolean;
  isCancelled?: boolean;
  style?: any;
  key?: any;
  borderBottom?: boolean;
  full?: boolean;
  children: ReactNode;
}

export default function Item(props: Props) {
  const { to, className, children, onClick, type, href } = props;
  const store = useStore();

  const styles = css`
    border-bottom: 1px solid ${colors.borderGray};
    padding: 1rem 1rem 1.2rem 1rem;
    color: ${colors.dark};
    display: block;
    /* transition: all .25s; */
    position: relative;
    max-width: ${props.full ? "none" : "800px"};
    margin: auto;
    background: #fff;
    & .fa-chevron-right:before {
      color: ${store.theme.orgColor};
    }
    ${cf}
    ${props.type === "student-info-request" && studentInfoRequestStyles}
    ${props.type === "communication" && communicationStyles}
    ${(props.isDetail || props.type === "detail") && detailStyles}
    ${props.isActive && activeStyles}
    ${props.approved === true && approvedStyles}
    ${props.approved === false && notApprovedStyles}
    ${props.isCancelled && cancelledStyles}
    ${props.borderBottom && borderBottomStyles}
    &:hover {
      color: ${colors.dark};
    }
  `;

  if (to) {
    return (
      <Link to={to} css={styles} className={className}>
        {children}
        {type === "communication" && (
          <IconContainer>
            <i className="far fa-chevron-right text-organization" />
          </IconContainer>
        )}
      </Link>
    );
  }

  if (href) {
    return (
      <a css={styles} className={className} href={href}>
        {children}
        {type === "communication" && (
          <IconContainer>
            <i className="far fa-chevron-right text-organization" />
          </IconContainer>
        )}
      </a>
    );
  }

  if (onClick) {
    return (
      <div css={styles} className={className} onClick={onClick}>
        {children}
        {type === "communication" && (
          <IconContainer>
            <i className="far fa-chevron-right text-organization" />
          </IconContainer>
        )}
      </div>
    );
  }

  return (
    <div css={styles} className={className}>
      {children}
      {type === "communication" && (
        <IconContainer>
          <i className="far fa-chevron-right text-organization" />
        </IconContainer>
      )}
    </div>
  );
}

const IconContainer = styled("div")`
  position: absolute;
  right: 1rem;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 1rem;
  height: 1rem;
  line-height: 1;
`;

const studentInfoRequestStyles = css`
  display: flex;
  align-items: center;
`;

const detailStyles = css`
  border: none;
  padding: 0;
`;

const communicationStyles = css`
  position: relative;
  padding-right: 3rem;
  &:last-child {
    /* border-bottom: 1px solid ${colors.borderGray}; */
    /* margin-bottom: -1px; */
  }
`;

const activeStyles = css`
  background: ${colors.paleAction};
`;

const bar = css`
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
  }
`;

const approvedStyles = css`
  position: relative;
  ${bar};
  &:before {
    background: ${colors.success};
  }
`;

const notApprovedStyles = css`
  position: relative;
  ${bar};
  &:before {
    background: ${colors.error};
  }
`;

const cancelledStyles = css`
  background: #fcf2f3;
`;

const borderBottomStyles = css`
  border-bottom: 1px solid ${colors.borderGray} !important;
`;
